import React from 'react'

export const TrapezoidShape = ({ children, className, position, size, direction, theme, ...props}) => {
    return <div className={`c-shape__wrapper c-shape__wrapper--${position} c-shape__wrapper--${direction} ${className}`}>
        <div className={`c-shape c-shape--${position} c-shape--${direction} c-shape--${size} c-shape--${theme}`}>
            {children}
        </div>
    </div>
}

export default TrapezoidShape



// WEBPACK FOOTER //
// ./src/components/TrapezoidShape.js